/// <reference path="../../apps/typings/customTds.d.ts"/>
/// <reference path="../../apps/typings/jquery-validation.d.ts"/>

import { BasicValidationService } from './BasicValidationService';
import { PrivacyConsentValidationService } from './PrivacyConsentValidationService';


export class MglValidationService<T extends MglAppDefinition> extends PrivacyConsentValidationService<T> {

	public static readonly ALREADY_VALIDATED_ATTR = "data-alreadyvalidated";

	public addCustomMethods(): void {
		super.addCustomMethods();

		$.validator.addMethod('under16', this.validatorUnder16.bind(this));

		$.validator.addMethod('salesman', this.validatorSalesman.bind(this));

		$.validator.addMethod('emailthirdparty', this.validatorEmailThirdparty.bind(this));

		$.validator.addMethod('emailsecondtry', this.validatorEmailSecondTry.bind(this));

		$.validator.addMethod('officeadvertisingkey', this.validatorOfficeAdvertisingKey.bind(this));
	}

	private validatorEmailSecondTry(value: any, element: HTMLElement, params: any): boolean {
		const $elm = $(element);
		//on second try email not required anymore
		if ($elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR)) {
			return this.validatorEmail(value, element, params);
		}
		else {
			$elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR, 'true');
			return value.length > 0 && this.validatorEmail(value, element, params);
		}
	}

	private validatorEmailThirdparty(value: any, element: HTMLElement, params: any): boolean {
		const $elm = $(element);
		//required on first party or first try,
		//on third party and second try email not required anymore
		if (this.options.app.isthirdpartyform && $elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR)) {
			//third party and second try => call standard validator
			return this.validatorEmail(value, element, params);
		}
		else {
			//validate and required
			$elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR, 'true');
			return value.length > 0 && this.validatorEmail(value, element, params);
		}
	}

	protected validatorSalesman(value: any, element: HTMLElement): boolean {
		if (!value.length) {
			return true;
		}
		const $elm = $(element);
		if ('Profiwerbernummer' === $elm.attr('name')) {
			if (6 > value.length) {
				return false;
			}
		}
		else if ('Pruefziffer' === $elm.attr('name') && (1 !== value.length || isNaN(value))) {
			return false;
		}
		if ($elm.length) {
			const valdata = $elm.attr(BasicValidationService.BACKEND_VALIDATION_ATTR);
			if (valdata) {
				return false;
			}
		}
		return true;
	}

	protected validatorUnder16(value: any, element: HTMLElement): boolean {
		// validate only Hauptmitglied
		if (element.id === "Geburtsdatum") {
			if (value.indexOf("-") === -1) {
				return moment(value, "DD.MM.YYYY") <= moment().subtract(16, 'years');
			}
			else {
				return moment(value, "YYYY-MM-DD") <= moment().subtract(16, 'years');
			}
		}
		return true;
	}

	protected evaluateMglRateCheckResponse(element: HTMLInputElement, data: JQueryXHR): [boolean, string] {
		let isValid = true, mglratecheckMsg = "";
		const messages = (data.responseJSON as ApiResponse<any>).Messages;

		if (element.id.indexOf("birthday_c") > -1) {
			for (const errMsg of messages) {
				const kindName = errMsg.Source.split("_")[0];
				if (kindName === "Kind") {
					isValid = false;
					mglratecheckMsg = this.errorService.getErrorMessage(errMsg);
					$(element).closest('div[data-clone="child"]').find('h3 .a-basic-link').show();
				}
			}
		} else if (element.id.indexOf("birth_adultchild") > -1 || element.id.indexOf("birth_child") > -1) {
			for (const errMsg of messages) {
				const kindName = errMsg.Source.split("_")[0];
				const kindNummer = Number(errMsg.Source.split("_")[1]);
				const isClone = $(":not(.h-hidden) .js-clone.is-visible").eq(kindNummer - 1).find(element).length > 0;
				if (kindName === "Kind" && isClone) {
					isValid = false;
					mglratecheckMsg = this.errorService.getErrorMessage(errMsg);
					$(element).closest('.js-clone').find('h3 .a-basic-link').show();
				}
			}
		} else if (element.name === "Geburtsdatum") {
			// Mitglied
			for (const errMsg of messages) {
				if (errMsg.Source === "ContractRequest_Mitglied" || errMsg.Source === "TarifempfehlungRequest") {
					isValid = false;
					mglratecheckMsg = this.errorService.getErrorMessage(errMsg);
				}
			}
		} else if (element.name === "GeburtsdatumPartner") {
			//Partner
			for (const errMsg of messages) {
				if (errMsg.Source === "ContractRequest_Partner") {
					isValid = false;
					mglratecheckMsg = this.errorService.getErrorMessage(errMsg);
				}
			}
		}
		return [isValid, mglratecheckMsg];
	}

	protected validatorOfficeAdvertisingKey(value: any, element: HTMLElement): boolean {
		if (!value.length) {
			return true;
		}
		const $elm = $(element);
		if ('GeschaeftsstellenWBS' === $elm.attr('name') && 4 > value.length) {
			return false;
		}

		return true;
	}

	public validatorOfficeAdvertisingKeySecondTry(value: any, element: HTMLElement): boolean {
		const $elm = $(element);
		//on second try OfficeAdvertisingKey not required anymore
		if ($elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR)) {
			return false;
		}
		else {
			$elm.attr(MglValidationService.ALREADY_VALIDATED_ATTR, 'true');
			return true;
		}
	}
}